// extracted by mini-css-extract-plugin
module.exports = {"results":"styles-module--results--3ns2E","header":"styles-module--header--15Xlw","right":"styles-module--right--33vsw"};